import { stringUtility } from "@repo/utilities/string.utility.ts";

interface IPrimaryCardSchema {
  isPrimary?: boolean;
  viewSchema: any;
  viewData: any;
  onClick?: () => void;
}
const PrimaryCard = ({
  isPrimary,
  viewSchema,
  viewData,
  onClick,
}: IPrimaryCardSchema) => {
  return (
    <button
      type="button"
      className={`flex flex-col border border-extraLightGray rounded-md h-fit py-1 w-60 ${
        isPrimary && "shadow-lg shadow-primary/20"
      } hover:shadow-primary/20  hover:cursor-pointer hover:shadow-md`}
      onClick={onClick}
    >
      <div className="border-b border-lightGray border-dashed flex justify-between p-1 h-7 w-full">
        {viewSchema?.map((viewUnit: any) => {
          const value = viewData?.[viewUnit?.accessKey] || "";

          return (
            <div className="flex text-xs gap-2" key={viewUnit?.label}>
              <p className="w-18 font-medium text-body  ">{viewUnit.label} :</p>
              <p className="font-semibold ">{value}</p>
            </div>
          );
        })}

        {isPrimary && (
          <p className="px-1.5 text-xs text-white bg-primary rounded-md">
            Primary
          </p>
        )}
      </div>
      <div className="flex flex-col py-2 px-2">
        <p className="text-sm font-medium">
          {" "}
          {stringUtility.addEllipsisAtEnd(viewData?.name, 22)}
        </p>
      </div>
    </button>
  );
};

export default PrimaryCard;
